export default __webpack_public_path__ + "fonts/64124f94b77a2cf84c5311e81efa3ce3.eot";